export default "__VITE_PUBLIC_ASSET__86999ceb__"